/**
 * How many dialogs (components/ui.tsx Modal) are open right now, for chrome that must stay out of a dialog's
 * way: the in-app update notice hides while one is open (a Refresh button floating over a form with unsaved
 * input would be a trap, and a focus-trapped keyboard user could not reach it anyway).
 */

let open = 0
const listeners = new Set<() => void>()
const emit = () => listeners.forEach((l) => l())

/** Count a dialog as open; returns the release, which is safe to call more than once (effect cleanup). */
export function trackModalOpen(): () => void {
  open += 1
  emit()
  let released = false
  return () => {
    if (released) return
    released = true
    open -= 1
    emit()
  }
}

export const anyModalOpen = (): boolean => open > 0

export function subscribeModalOpen(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
